import { render } from "./Slot.vue?vue&type=template&id=0faffcfe&scoped=true"
import script from "./Slot.vue?vue&type=script&lang=js"
export * from "./Slot.vue?vue&type=script&lang=js"

import "./Slot.vue?vue&type=style&index=0&id=0faffcfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0faffcfe"]])

export default __exports__